import { Box } from '@mui/material';
import ExoAvatar from './ExoAvatar';

const getImageUrl = (img) => {
  if (!img) return undefined;
  if (typeof img === 'string') return img;
  return img.temporaryUrl || img.thumbnailUrl;
};

const ExoTableRecipient = ({ row, key = 'recipient' }) => {
  const recipient = row[key];

  if (!recipient) return null;

  const urlMap = {
    company: `/companies/${recipient.id}`,
    contact: `/contacts/${recipient.id}`,
  };

  return (
    <Box
      className="flex flex-row gap-2 justify-start sm:justify-start items-center w-full"
      href={urlMap[row.recipientType]}
    >
      {row.recipientType === 'company' && (
        <ExoAvatar
          picture={getImageUrl(recipient.image) || getImageUrl(recipient.logo)}
          name={recipient.name}
          size="35px"
          type="company"
        />
      )}
      {row.recipientType === 'contact' && (
        <ExoAvatar
          name={(recipient.firstName || '') + ' ' + (recipient.lastName || '')}
          size="35px"
          colorPoolId={recipient.colorPoolId}
        />
      )}
      {row.recipientType === 'company_lead' && (
        <ExoAvatar
          picture={getImageUrl(recipient.image) || getImageUrl(recipient.logo)}
          name={recipient.name}
          size="35px"
          type="company"
        />
      )}
      {row.recipientType === 'person_lead' && (
        <ExoAvatar
          name={(recipient.firstName || '') + ' ' + (recipient.lastName || '')}
          size="35px"
          colorPoolId={recipient.colorPoolId}
        />
      )}
      <Box className="hidden md:block">
        {row.recipientType === 'contact' &&
          (recipient?.firstName || '') + ' ' + (recipient?.lastName || '')}
        {row.recipientType === 'company' && recipient?.name}
        {row.recipientType === 'company_lead' && recipient?.name}
        {row.recipientType === 'person_lead' &&
          (recipient?.firstName || '') + ' ' + (recipient?.lastName || '')}
      </Box>
    </Box>
  );
};

export default ExoTableRecipient;
